import { isBrowser, SaveProduct } from '@croquiscom/web2app';
import { useAtom } from 'jotai';

import { ActionOptionalLog, ZigzagEvent } from '@common/app-manager';
import { useLandingPopup } from '@common/overlay-manager';
import { useIsApp } from '@domains/pdp-common';

import { likeLookupAtom } from '../store/likeLookupAtom';

interface Config {
  catalog_product_id: string;
}

interface LikePayload extends SaveProduct {
  like: boolean;
  log?: ActionOptionalLog;
}

export const useLike = ({ catalog_product_id }: Config) => {
  const { is_app } = useIsApp();
  const { open: openLandingPopup } = useLandingPopup();
  const [lookup, setLookup] = useAtom(likeLookupAtom);
  const like = lookup[catalog_product_id] ?? false;

  const toggleLike = ({ like, log, ...rest }: LikePayload) => {
    if (isBrowser() && !is_app) {
      openLandingPopup();
      return;
    }

    setLookup((prev) => ({ ...prev, [catalog_product_id]: like }));
    if (like) {
      return ZigzagEvent.sp(
        {
          browsingType: rest.browsingType,
          shopId: rest.shopId,
          shopProductNo: rest.shopProductNo,
          catalogProductId: rest.catalogProductId,
          title: rest.title,
          goodsUrl: rest.goodsUrl,
          imageUrl: rest.imageUrl,
          price: rest.price,
          discountRate: rest.discountRate,
          isZpay: rest.isZpay,
          isFreeShipping: rest.isFreeShipping,
        },
        log,
      );
    }

    return ZigzagEvent.rsp(
      {
        shopId: rest.shopId,
        shopProductNo: rest.shopProductNo,
        catalogProductId: rest.catalogProductId,
      },
      log,
    );
  };

  return { like, toggleLike };
};
